import React from 'react'
import styles from './styles.module.scss'
import ImageFallback from '@/src/components/helpers/image-fallback/image-fallback'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import BaseLoading from '../../helpers/base-loading/base-loading'

interface Props {
    className?: string
}

export default function MerchantLogo(props: Props) {
    const { merchantSummary } = useMerchant()

    return (
        <div className={`${styles.container} ${props.className}`}>
            {
                !merchantSummary
                    ?
                    <BaseLoading>
                        <aside className={styles.logo} />
                    </BaseLoading>
                    :
                    <ImageFallback
                        src={`${merchantSummary.logoUrl}`}
                        alt={`Logo ${merchantSummary?.name}`}
                        className={styles.logo}
                        isMerchantImage
                    />
            }
        </div>
    )
}
